import { memo } from 'react';

import StarIconSVG from '@/assets/star-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IStarIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={StarIconSVG} {...props} />;

export const StarIcon = memo(IStarIcon) as typeof IStarIcon;
